import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import userImg from '../assets/images/user.svg';
import soccerballImg from '../assets/images/soccerball.svg';
import srcardImg from '../assets/images/srcard.svg';
import clockImg from '../assets/images/clock.svg';
import settingImg from '../assets/images/setting.svg';
import HelpinfoImg from '../assets/images/Helpinfo.svg';
import logoutImg from '../assets/images/logout.svg';
import srbookImg from '../assets/images/srbook.svg';

import DollarBlueIcon from '../assets/images/dollar-blue-icon.svg'

import { DEV_API } from '../const';
import { logoutAct } from '../store/actions/authActions';
import CustomModal from './Modal/modal';

const SideMenu = (props) => {
    const { menuOpen, user, handleMenuToggle } = props;
    const dispatch = useDispatch();

    const { token, loading, error } = useSelector((state) => state.auth);

    const [scoringRules, setScoringRules] = useState([]);
    const [selectedSport, setSelectedSport] = useState(-1);
    const [scoringRulesModalIsOpen, setScoringRulesModalIsOpen] = useState(false);
    const [helpModalIsOpen, setHelpModalIsOpen] = useState(false);

    useEffect(() => {
        // fetch scoring rules data
        axios.get(`${DEV_API}/api/sports/getallscoringrules`, {
            // params: {
            //   player: user._id,
            //   win: [1, 2]
            // }
        }).then((response) => {
            const fetchedScoringRules = response.data.result || [];
            setScoringRules(fetchedScoringRules);
        });
    }, [])

    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflowX = 'hidden';
            // document.body.style.overflowY = 'hidden';
            document.documentElement.style.overflowX = 'hidden';
            // document.documentElement.style.overflowY = 'hidden';
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
    }, [menuOpen]);

    const handleLogout = () => {
        console.log(token, 'logout')
        dispatch(logoutAct());
    }

    const handleClckScoringRules = () => {
        if (scoringRules.length > 0) setSelectedSport(0);
        // handleMenuToggle()
        setScoringRulesModalIsOpen(true);
    }

    return (
        <>
            {/* Side Menu */}
            <div className={`side-menu ${menuOpen ? 'open' : ''}`} style={{ maxWidth: 430, margin: '0 auto', minHeight: 900, display: menuOpen ? 'block' : 'none' }}>
                <div className='side-menu-content'>
                    <div className='profile-photo-block'>
                        {/* <div className='profile-photo'>
                            <img src={profileImg} alt="profile" className='img-fluid' />
                        </div> */}
                        <div className='profile-name-info'>
                            <h4>{user ? user.name : ''}</h4>
                        </div>
                    </div>
                    <div className='money-balance'>
                        <span>${user ? user.balance : '0'}</span>
                    </div>
                    <div className='menu-list'>
                        <ul>
                            <li><Link to="/myaccount"><img src={userImg} alt="user" className='img-fluid' />My Account</Link></li>
                            <li><Link to="/activeGames"><img src={DollarBlueIcon} alt="soccerball" className='img-fluid' style={{ width: 32 }} />Active $ Games</Link></li>
                            <li><Link to="/paymentsEdit"><img src={srcardImg} alt="srcard" className='img-fluid' />Payout Source</Link></li>
                            <li><Link to="/gameHistory"><img src={clockImg} alt="clock" className='img-fluid' />Game History</Link></li>
                            {/* <li><Link><img src={settingImg} alt="setting" className='img-fluid' />Settings</Link></li> */}
                            <li onClick={() => setHelpModalIsOpen(true)}><Link><img src={HelpinfoImg} alt="Helpinfouser" className='img-fluid' />Help</Link></li>
                            <li><Link to="/howToPlay"><img src={clockImg} alt="clock" className='img-fluid' />How To Play</Link></li>
                            <li onClick={() => handleClckScoringRules()}><Link><img src={srbookImg} alt="srbook" className='img-fluid sr-book' />Rules</Link></li>
                            <li><Link onClick={handleLogout}><img src={logoutImg} alt="logout" className='img-fluid' />Log out</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <CustomModal
                modalIsOpen={helpModalIsOpen}
                primaryColor="#0d6efd"
                backgroundColor="#f3bb0b"
                // borderRadius={0}
                setModalIsOpen={setHelpModalIsOpen}
                onRequestClose={() => setHelpModalIsOpen(false)}
            >
                <div className='mb-4'>
                    <p className='fw-bold fs-3 text-center'>
                        For questions or comments:
                    </p>
                </div>
                <div>
                    <p className='fw-bold fs-3 text-center'>
                        Contact BallHog
                    </p>
                    <p className='fw-bold fs-3 text-center'>
                        808-272-3878
                    </p>
                    <p className='fw-bold fs-3 text-center'>
                        help@playballhog.com
                    </p>
                </div>
            </CustomModal>
            <CustomModal
                modalIsOpen={scoringRulesModalIsOpen}
                primaryColor="#0d6efd"
                setModalIsOpen={setScoringRulesModalIsOpen}
                onRequestClose={() => setScoringRulesModalIsOpen(false)}
            >
                <div className='mb-4'>
                    <p className='fw-bold fs-3 text-center'>
                        RULES
                    </p>
                </div>
                <div className='mb-3'>
                    <Form.Select onChange={(e) => { setSelectedSport(e.target.value) }}>
                        {
                            scoringRules.map((rule, idx) => {
                                return (
                                    <option key={idx} value={idx}>{rule.sportName}</option>
                                )
                            })
                        }
                    </Form.Select>
                </div>
                <ReactQuill theme='bubble' readOnly={true} value={selectedSport != -1 && scoringRules[selectedSport].rules} />
            </CustomModal>
        </>
    );
};

export default SideMenu;
